module.exports = __webpack_public_path__ + "static/img/fundManager.a3e5417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/fundManager.jpg
// module id = g5Ls
// module chunks = 0